<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import HeroSection from '@/Pages/Home/Partials/HeroSection.vue'
import ServicesSection from '@/Pages/Home/Partials/ServicesSection.vue'
import SecondSection from '@/Pages/Home/Partials/SecondSection.vue'
import ThirdSection from '@/Pages/Home/Partials/ThirdSection.vue'
import FourthSection from '@/Pages/Home/Partials/FourthSection.vue'
import CTASection from '@/Pages/Home/Partials/CTASection.vue'

const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <AppLayout
        meta_title="Daňové přiznání pro OSVČ online – Jednoduché a rychlé podání"
        meta_description="Jste OSVČ a hledáte snadný způsob, jak podat daňové přiznání online? S námi to zvládnete rychle a bez stresu. Ušetřete čas a vyhněte se chybám při podání daní."
    >
        <template #content>
            <HeroSection :product_price="product?.price" />

            <SecondSection />

            <ThirdSection />

            <ServicesSection />

            <CTASection />

            <FourthSection />
        </template>
    </AppLayout>
</template>
